import { Injectable } from "@angular/core";
import { AutomationFunctionCodes } from "@app/models/functioninfo/automationfunctioncodes.model";

@Injectable({ providedIn: "root" })
export class AutomationUtilService {
  public functions = new Map<string, string>();
  public disciplines = new Map<number, string>();


  constructor() {
    this.fillFunctions();
    this.fillDisciplines();
  }

  public fillFunctions() {
    this.functions.set(AutomationFunctionCodes.BillOfQuantities_CAD, "Bill_Of_Quantities");
    this.functions.set(AutomationFunctionCodes.BillofQuantities_AACS, "Bill_Of_Quantities");
    this.functions.set(AutomationFunctionCodes.BillofQuantities_CCTV, "Bill_Of_Quantities");
    this.functions.set(AutomationFunctionCodes.BillofQuantities_IHAS, "Bill_Of_Quantities");

    this.functions.set(AutomationFunctionCodes.RevisionTracker_AACS, "Revision_Tracker");
    this.functions.set(AutomationFunctionCodes.RevisionTracker_CCTV, "Revision_Tracker");
    this.functions.set(AutomationFunctionCodes.RevisionTracker_IHAS, "Revision_Tracker");

    this.functions.set(AutomationFunctionCodes.HardwareSheet_AACS, "CAD_To_Hardware_Sheet");
    this.functions.set(AutomationFunctionCodes.HardwareSheet_CCTV, "CAD_To_Hardware_Sheet");
    this.functions.set(AutomationFunctionCodes.HardwareSheet_IHAS, "CAD_To_Hardware_Sheet");

    this.functions.set(AutomationFunctionCodes.ExportSheetData, "Export_Sheet_Data");
    this.functions.set(AutomationFunctionCodes.ExportTagData, "Export_Tag_Data");
    this.functions.set(AutomationFunctionCodes.ImportSheetData, "Import_Sheet_Data");
    this.functions.set(AutomationFunctionCodes.ImportTagData, "Import_Tag_Data");

    this.functions.set(AutomationFunctionCodes.CommissioningSheets_AACS, "Hardware_To_Commissioning_Sheet");
    this.functions.set(AutomationFunctionCodes.CommissioningSheets_CCTV, "Hardware_To_Commissioning_Sheet");
    this.functions.set(AutomationFunctionCodes.CommissioningSheets_IHAS, "Hardware_To_Commissioning_Sheet");

    this.functions.set(AutomationFunctionCodes.ComponentCount, "Component_Count");
    this.functions.set(AutomationFunctionCodes.DoorWizard, "Door_Wizard");
    this.functions.set(AutomationFunctionCodes.ErrorCheck, "Error_Check");

    this.functions.set(AutomationFunctionCodes.Schematics_AACS, "Schematics_Generator");
    this.functions.set(AutomationFunctionCodes.Schematics_CCTV, "Schematics_Generator");
    this.functions.set(AutomationFunctionCodes.Schematics_IHAS, "Schematics_Generator");

    this.functions.set(AutomationFunctionCodes.HardwareOAndMManual_AACS, "HardwareOandM");
    this.functions.set(AutomationFunctionCodes.HardwareOAndMManual_CCTV, "HardwareOandM");
    this.functions.set(AutomationFunctionCodes.HardwareOAndMManual_IHAS, "HardwareOandM");

    this.functions.set(AutomationFunctionCodes.DesignToDestination_AACS, "Design_To_Destination");
    this.functions.set(AutomationFunctionCodes.DesignToDestination_CCTV, "Design_To_Destination");
    this.functions.set(AutomationFunctionCodes.DesignToDestination_IHAS, "Design_To_Destination");

    this.functions.set(AutomationFunctionCodes.ReverseAutomatorAacs, "ReverseAutomator");
    this.functions.set(AutomationFunctionCodes.ReverseAutomatorCctv, "ReverseAutomator");
    this.functions.set(AutomationFunctionCodes.ComponentNumber, "Component_Number");

    this.functions.set(AutomationFunctionCodes.CableEstimation, "CablingEstimation");

    this.functions.set(AutomationFunctionCodes.DocumentGenerator, "InitUpdateFiles");

    this.functions.set(AutomationFunctionCodes.DesignAssistant, "Design_Assistant");
  }

  public fillDisciplines() {
    this.disciplines.set(13, "CAD");
    this.disciplines.set(1, "AACS");
    this.disciplines.set(3, "CCTV");
    this.disciplines.set(7, "IHAS");
    this.disciplines.set(10,"VCOM")
  }

  public getDisciplineNameFromRouteParam(disciplineId: number): string {
    var returnValue: string = "-";

    try {
      returnValue = this.disciplines.get(disciplineId);
    } finally {
      return returnValue;
    }
  }

  public getProgramNameFromFunction(functionCode: string): string {
    var returnValue: string = "-";

    try {
      returnValue = this.functions.get(functionCode);
    } finally {
      return returnValue;
    }
  }
}
